module.exports = __webpack_public_path__ + "img/bgTitle1.9b21b174.png";